import React from 'react'
import featureFlags from '../../configuration/featureFlags';
import siteConfig from '../../configuration/siteConfiguration';
import "./VerticalDetails.css";
import Divider from '../VerticalsWePower/Divider';
import { ProductStatistics } from './ProductStatistics';
import ProductUseCases from './ProductUseCases';
import RequestInfo from '../RequestInfo/RequestInfo';

const VertDetMainSection = ({
    keyFeaturesCards,
    title,
    subtitle,
    description,
    benefits
}) => {
    const leftCards = keyFeaturesCards?.length > 0 ? keyFeaturesCards.slice(0, 3) : [];
    const rightCards = keyFeaturesCards?.length > 0 ? keyFeaturesCards.slice(3, 7) : [];

    return (
        <div className="vert-det-section">
            <div className="vert-det-left">
                <div className="vert-det-label-row">
                    <span className="vert-det-label-line"></span>
                    <span className="vert-det-label">{title}</span>
                </div>
                <h2 className="vert-det-title">{subtitle}</h2>
                <p className="vert-det-desc">
                    {description}
                </p>
                {benefits && (
                    <div className="vert-det-benefits-container">
                        <ul className="vert-det-benefits">
                            {benefits.map((benefit, idx) => (
                                <li key={idx}>
                                    <img className="vert-det-icon" src={benefit.icon} alt={benefit.title} />
                                    <span className="vert-det-benefit-text">{benefit.title}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {featureFlags.legal.showDemoLink &&
                    <div className="vert-det-buttons">
                        <button className="vert-det-btn primary">
                            <span className="vert-det-btn-primary-text">Get started</span>
                            <span className="vert-det-btn-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M14 6.5C14 6.63261 13.9473 6.75979 13.8536 6.85355C13.7598 6.94732 13.6326 7 13.5 7C13.3674 7 13.2402 6.94732 13.1464 6.85355C13.0527 6.75979 13 6.63261 13 6.5V3.7075L8.85437 7.85375C8.76055 7.94757 8.63331 8.00028 8.50062 8.00028C8.36794 8.00028 8.2407 7.94757 8.14688 7.85375C8.05305 7.75993 8.00035 7.63268 8.00035 7.5C8.00035 7.36732 8.05305 7.24007 8.14688 7.14625L12.2925 3H9.5C9.36739 3 9.24021 2.94732 9.14645 2.85355C9.05268 2.75979 9 2.63261 9 2.5C9 2.36739 9.05268 2.24021 9.14645 2.14645C9.24021 2.05268 9.36739 2 9.5 2H13.5C13.6326 2 13.7598 2.05268 13.8536 2.14645C13.9473 2.24021 14 2.36739 14 2.5V6.5ZM11.5 8C11.3674 8 11.2402 8.05268 11.1464 8.14645C11.0527 8.24021 11 8.36739 11 8.5V13H3V5H7.5C7.63261 5 7.75979 4.94732 7.85355 4.85355C7.94732 4.75979 8 4.63261 8 4.5C8 4.36739 7.94732 4.24021 7.85355 4.14645C7.75979 4.05268 7.63261 4 7.5 4H3C2.73478 4 2.48043 4.10536 2.29289 4.29289C2.10536 4.48043 2 4.73478 2 5V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H11C11.2652 14 11.5196 13.8946 11.7071 13.7071C11.8946 13.5196 12 13.2652 12 13V8.5C12 8.36739 11.9473 8.24021 11.8536 8.14645C11.7598 8.05268 11.6326 8 11.5 8Z" fill="white" />
                                </svg>
                            </span>
                        </button>
                        <button className="vert-det-btn secondary">
                            <span className="vert-det-btn-secondary-text">Live demo</span>
                        </button>
                    </div>}
            </div>
            <div className="vert-det-right">
                <div className="vert-det-columns-animate">
                    <div className="vert-det-column vert-det-column-down">
                        {leftCards.concat(leftCards).map((card, idx) => (
                            <div className="feature-card" key={'down-' + idx + '-' + card.id}>
                                <div className="feature-card-header">
                                    {card?.icon?.indexOf("http") === 0 ? (
                                        <img src={card.icon} alt="feature icon" />
                                    ) : (
                                        <img src={`${siteConfig.assetBaseUrl}/icons/legal/hero-section---VertDetMainSection.ai/${card.icon}`} alt="feature icon" />
                                    )}
                                    <div className="feature-card-title">{card.mainTitle || " "}</div>
                                </div>
                                <div className="feature-card-description">
                                    {card.title}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="vert-det-column vert-det-column-up">
                        {rightCards.concat(rightCards).map((card, idx) => (
                            <div className="feature-card" key={'up-' + idx + '-' + card.id}>
                                <div className="feature-card-header">
                                    {card?.icon?.indexOf("http") === 0 ? (
                                        <img src={card.icon} alt="feature icon" />
                                    ) : (
                                        <img src={`${siteConfig.assetBaseUrl}/icons/legal/hero-section---VertDetMainSection.ai/${card.icon}`} alt="feature icon" />
                                    )}
                                    <div className="feature-card-title">{card.mainTitle || " "}</div>
                                </div>
                                <div className="feature-card-description">
                                    {card.title}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};


export default function VerticalDetails({ keyFeaturesCards, mainSection, productStats, productUseCases, requestInfoTitle }) {
    return (
        <>
            <VertDetMainSection
                keyFeaturesCards={keyFeaturesCards}
                title={mainSection.title}
                subtitle={mainSection.subtitle}
                description={mainSection.description}
                benefits={mainSection?.benefits}
            />
            <Divider />
            <ProductStatistics stats={productStats} />
            <Divider />
            <ProductUseCases title={mainSection.title} useCaseDetails={productUseCases} />
            <Divider />
            <RequestInfo title={requestInfoTitle} />
        </>
    )
}

